import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconMail = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.60856 7.67197C6.62738 7.66854 6.64669 7.66675 6.66634 7.66675H17.333C17.3528 7.66675 17.3722 7.66856 17.3911 7.67204L11.9999 11.4459L6.60856 7.67197ZM6.33301 9.9204V16.0001C6.33301 16.1811 6.48529 16.3334 6.66634 16.3334H17.333C17.5141 16.3334 17.6663 16.1811 17.6663 16.0001V9.92071L12.5734 13.4858C12.229 13.7268 11.7708 13.7268 11.4264 13.4858L6.33301 9.9204ZM6.66634 5.66675C5.38072 5.66675 4.33301 6.71446 4.33301 8.00008V16.0001C4.33301 17.2857 5.38072 18.3334 6.66634 18.3334H17.333C18.6186 18.3334 19.6663 17.2857 19.6663 16.0001V8.00008C19.6663 6.71446 18.6186 5.66675 17.333 5.66675H6.66634Z"
        />
      </svg>
    );
  }
);
